// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"cd00df6e","233":"88d39b9c","369":"548b5026","777":"d85915b3","936":"5566c6a5"}[chunkId] + ".js";
};